import { Modal } from '../models';

export class CanceledModalError extends Error {
    constructor(public modal: Modal) {
        super('Modal was canceled');
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, CanceledModalError.prototype);
    }
}
